import { Pipe, PipeTransform } from '@angular/core';
import { SLMovementLineShareType } from './movement';

@Pipe({ name: 'slmovementlinesharetype' })
export class SLMovementLineShareTypePipe implements PipeTransform {

  transform(value: SLMovementLineShareType, ...args: any[]) {
    let short = false;

    if (args && args.length > 0 && args[0] === 'short') {
      short = true;
    }

    if (value === 'ORD') {
      return short ? 'Ord' : 'Ordinaire';
    }
    else if (value === 'PREF') {
      return short ? 'Préf' : 'Préférence';
    }
    else if (value === 'BSA') {
      return 'BSA';
    }
    else if (value === 'BSPCE') {
      return 'BSPCE';
    }
    else if (value === 'AGA') {
      return 'AGA';
    }
    else if (value === 'SO') {
      return 'S-O';
    }
    else {
      return value;
    }
  }
}
